import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import './Draggable.scss';

const getPosition = (ev, el) => {
  // eslint-disable-next-line react/no-find-dom-node
  const node = findDOMNode(el);
  const offsetParent = node.offsetParent || node.ownerDocument.body;
  const isBody = offsetParent === offsetParent.ownerDocument.body;

  const offsetParentRect = isBody
    ? {
        left: 0,
        top: 0,
      }
    : offsetParent.getBoundingClientRect();

  const { clientX, clientY } = ev.type === 'touchmove' ? ev.touches[0] : ev;

  return {
    x: clientX + offsetParent.scrollLeft - offsetParentRect.left,
    y: clientY + offsetParent.scrollTop - offsetParentRect.top,
  };
};

const eventNames = {
  touch: {
    move: 'touchmove',
    stop: 'touchend',
  },
  mouse: {
    move: 'mousemove',
    stop: 'mouseup',
  },
};

class Draggable extends Component {
  static propTypes = {
    onDrag: PropTypes.func.isRequired,
    grid: PropTypes.array,
  };

  state = {
    dragging: false,
    prevX: 0,
    prevY: 0,
  };

  onDragStop = () => {
    this.setState({ dragging: false });
  };

  onDragMove = (ev) => {
    const { grid, onDrag } = this.props;

    const { dragging, prevX, prevY } = this.state;

    if (!dragging) {
      return;
    }

    ev.preventDefault();

    let { x, y } = getPosition(ev, this);

    if (Array.isArray(grid)) {
      const diffX = x - prevX;
      const diffY = y - prevY;

      const deltaX = Math.round(diffX / grid[0]) * grid[0];
      const deltaY = Math.round(diffY / grid[1]) * grid[1];

      if (!deltaX && !deltaY) {
        return;
      }

      x = prevX + deltaX;
      y = prevY + deltaY;
    }

    onDrag({ x, y });

    this.setState({
      prevX: x,
      prevY: y,
    });
  };

  addEvents = (type, opts) => {
    window.addEventListener(eventNames[type].stop, this.onDragStop, opts);

    window.addEventListener(eventNames[type].move, this.onDragMove, opts);
  };

  removeEvents = () => {
    window.removeEventListener('mouseout', this.onDragStop);
    window.removeEventListener('mousemove', this.onDragMove);
    window.removeEventListener('touchend', this.onDragStop);
    window.removeEventListener('touchmove', this.onDragMove);
  };

  enabledEvents = {
    mouse: false,
    touch: false,
  };

  enableEvents = (type) => {
    if (this.enabledEvents[type]) {
      return;
    }

    try {
      let supportsPassive = false;

      const opts = Object.defineProperty({}, 'passive', {
        get() {
          supportsPassive = true;
          return false;
        },
      });

      this.addEvents(type, opts);

      if (!supportsPassive) {
        this.removeEvents();
        this.addEvents(type, false);
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error(err);
      }

      this.addEvents(type, false);
    }

    this.enabledEvents[type] = true;
  };

  componentWillUnmount = () => this.removeEvents();

  render() {
    const { style } = this.props;

    return (
      <div
        style={style}
        className="draggable"
        onMouseDown={(ev) => {
          ev.preventDefault();
          this.enableEvents('mouse');
          this.setState({ dragging: true });
        }}
        onTouchStart={(ev) => {
          ev.preventDefault();
          this.enableEvents('touch');
          this.setState({ dragging: true });
        }}
      >
        <i className="icon-cursor-move" />
      </div>
    );
  }
}

export default Draggable;
